import * as DateUtil from "@/common/utils/DateUtil";
import * as StringUtil from "@/common/utils/StringUtil";
// import * as ClipboardUtil from "@/common/utils/ClipboardUtil";
// import * as ToastUtil from "@/common/utils/ToastUtil";

import { ComponentOptions, defineComponent } from "vue";

import * as routerUtil from "@/common/utils/routerUtil";
import * as api from "@/common/api/index";
import * as core from "@/common/utils/core";
import * as deviceUtil from "@/common/utils/deviceUtil";
// import * as LSUtil from "@/common/utils/storage";

export default defineComponent({
  methods: {
    getCore() {
      return core;
    },
    getApi() {
      return api;
    },
    getRouterUtil() {
      return routerUtil;
    },
    getStringUtil() {
      return StringUtil;
    },

    //////////////////
    // string
    getPhoneFormat(phone: string): string {
      return StringUtil.getPhoneFormat(phone);
    },
    getMoneyFormat(money: number): string {
      return StringUtil.getMoneyFormat(money);
    },
    getMoneyFormatByString(number: string): string {
      return StringUtil.getMoneyFormatByString(number);
    },
    extractNumber(value: string): string {
      return StringUtil.extractNumber(value);
    },
    isEmpty(text: string): boolean {
      return StringUtil.isEmpty(text);
    },

    //////////////////
    // date
    getDateFormat(date: string, format: string): string {
      return DateUtil.getDate(date, format);
    },
    getDateFormatByTimestamp(timestamp: number, format: string): string {
      return DateUtil.getDateFormatByTimestamp(timestamp, format);
    },

    ////////////////
    copy(text: string) {
      // return ClipboardUtil.copyToClipboard(text);
    },

    ////////////////
    // device
    ////////////////
    isDesktop(): boolean {
      return deviceUtil.isDesktop();
    },

    ////////////////
    // toast
    // toastSuccess(text: string) {
    //   ToastUtil.success(text);
    // },
    // toastWarn(text: string) {
    //   ToastUtil.warn(text);
    // },
    // toastError(text: string) {
    //   ToastUtil.error(text);
    // },
  },
});
